import { HIDE_CONFIRM_DIALOG } from '../../../../vuex/modules/confirm-dialog/types'
import {
  NOTIFY_ERROR,
  NOTIFY_SUCCESS
} from '../../../../vuex/modules/snackbar/types'
import apiCalls, {
  getAccounts,
  getFees,
  getInvestors,
  updateFees
} from '../apiCalls'
import * as types from './types'

const mapper = function (source) {
  const mappedObj = { fees: [], custom_fees: [] }

  Object.keys(source).forEach((country) => {
    Object.keys(source[country].fees).forEach((grade) => {
      if (
        !!source[country].fees[grade] &&
        source[country].fees[grade].fee > 0
      ) {
        mappedObj.fees.push(source[country].fees[grade])
      }
    })

    if (source[country].custom_fees) {
      Object.keys(source[country].custom_fees).forEach((accountId) => {
        Object.keys(source[country].custom_fees[accountId]).forEach((grade) => {
          if (
            !!source[country].custom_fees[accountId][grade] &&
            source[country].custom_fees[accountId][grade].fee > 0
          ) {
            mappedObj.custom_fees.push({
              grade: grade,
              account_id:
                source[country].custom_fees[accountId][grade].account_id,
              fee: source[country].custom_fees[accountId][grade].fee,
              country_code: country,
              product_type:
                source[country].custom_fees[accountId][grade].product_type
            })
          }
        })
      })
    }
  })
  return mappedObj
}

export default {
  [types.GET_PRICINGS]({ commit, dispatch }) {
    commit(types.SET_LOADING, true)
    getFees()
      .then((resp) => {
        commit(types.SET_PRICING_FEES, resp)
      })
      .catch((err) => {
        console.error(err)
        dispatch(NOTIFY_ERROR, { message: err.response.data })
      })
      .finally(() => commit(types.SET_LOADING, false))
  },
  [types.UPDATE_AVAILABLE_COUNTRIES]({ commit, getters }, newCountries) {
    const currentCountries = getters[types.GET_AVAILABLE_COUNTRIES]
    const addedCountries = newCountries.filter(
      (country) => !currentCountries.includes(country)
    )
    const removedCountries = currentCountries.filter(
      (country) => !newCountries.includes(country)
    )

    if (addedCountries.length || removedCountries.length) {
      commit(types.STATE_MODIFIED)
      addedCountries.forEach((CCode) => commit(types.ADD_COUNTRY, CCode))
      removedCountries.forEach((CCode) => commit(types.REMOVE_COUNTRY, CCode))
    }
  },
  [types.ROLL_CHANGES_BACK]({ commit, state }, discard = false) {
    commit(types.SET_PRICING_FEES, state.raw_response)
    commit(HIDE_CONFIRM_DIALOG)
    if (discard) commit(types.SET_EDIT_MODE, false)
  },
  [types.SAVE_CHANGES]({ commit, dispatch, state }) {
    const source = state.pricing[state.selectedProduct]
    const mappedObj = mapper(source)

    commit(types.SET_LOADING, true)
    commit(HIDE_CONFIRM_DIALOG)
    updateFees(mappedObj, state.selectedProduct)
      .then(() => {
        dispatch(NOTIFY_SUCCESS, {
          message: 'Pricing fees successfully updated. Reloading'
        })
        setTimeout(() => {
          window.location.reload()
        }, 2500)
      })
      .catch((err) => {
        console.error(err)
        dispatch(NOTIFY_ERROR, { message: err.response.data })
      })
      .finally(() => {
        commit(types.SET_LOADING, false)
      })
  },
  async [types.GET_ACCOUNTS]({ commit, dispatch }) {
    commit(types.SET_CUSTOM_FEE_DIALOG_OPTIONS, { loading: true })
    try {
      let accounts = []
      const investors = await getInvestors()
      for (let index = 0; index < investors.length; index++) {
        const investorAccounts = await getAccounts({
          owner_id: investors[index].id
        })
        accounts = [...accounts, ...investorAccounts.results]
      }
      commit(types.SET_ACCOUNTS, accounts)
      commit(types.SET_CUSTOM_FEE_DIALOG_OPTIONS, { loading: false })
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    }
  },
  [types.GET_SUPPORTED_COUNTRIES]({ commit, dispatch }) {
    apiCalls
      .getSupportedCountries()
      .then((countries) => {
        commit(
          types.SET_SUPPORTED_COUNTRIES,
          countries.map((country) => country.code)
        )
      })
      .catch((err) => {
        console.error(err)
        dispatch(NOTIFY_ERROR, { message: err.response.data })
      })
  }
}
